import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import LogoutRoute from './LogoutRoute';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  const { routes } = MainRoutes();
  return useRoutes([LoginRoutes, routes, LogoutRoute]);
}
